import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form as Formsy } from 'formsy-react';
import Dialog from 'material-ui/Dialog';
import SelectSkill from '../Skill/SelectSkill';
import { asDialog } from '../Common/Decorators';
import { UserDialogs } from '../../constants/Dialogs';
import DialogActions from '../../actions/DialogActionCreator';
import DatePicker from '../Common/DatePicker';
import TextField from '../Common/TextField';
import FlatButton from 'material-ui/FlatButton';
import UserActions from '../../actions/UserActionCreator';

class UserSkillDialog extends Component {

    componentDidMount() {
        this.onSubmit = this.onSubmit.bind(this);
    }

    render() {
        return (
            <Dialog
                title={!this.props.draft.isEdit ? "Add Skill" : "Edit Skill"}
                open={this.props.open === UserDialogs.USER_SKILL_DIALOG}
                modal={false}
                onRequestClose={DialogActions.close}
                autoScrollBodyContent
            >
                <Formsy onSubmit={this.onSubmit}>
                    {!this.props.draft.isEdit && (
                        <SelectSkill
                            clearOnSelect={false}
                            onSelect={(skillName = null, skillId = null) => DialogActions.updateDraft('skill', {skillName, skillId})}
                            onUpdate={() => DialogActions.updateDraft('skill', {})}
                        />
                    )}
                    <DatePicker name="dateAcquired" value={!this.props.draft.isEdit ? new Date() : new Date(this.props.draft.skill.dateAcquired)} floatingLabelText="Date Acquired" required />
                    <TextField name="grade" hintText="Grade" floatingLabelText="Grade" value={!!this.props.draft.isEdit && this.props.draft.skill.grade}/>
                    <TextField name="score" hintText="Score" floatingLabelText="Score" value={!!this.props.draft.isEdit && this.props.draft.skill.score}/>
                    <TextField name="notes" hintText="Notes" floatingLabelText="Notes" value={!!this.props.draft.isEdit && this.props.draft.skill.notes}/>
                    <TextField name="cpdCredits" hintText="CPD credits" floatingLabelText="CPD credits" value={!!this.props.draft.isEdit && this.props.draft.skill.cpdCredits}/>
                    <TextField name="location" hintText="Location" floatingLabelText="Location" value={!!this.props.draft.isEdit && this.props.draft.skill.location}/>
                    <br /><br />
                    <div style={{textAlign: "right"}}>
                        <FlatButton key="cancel" label="Cancel" onTouchTap={DialogActions.close} />
                        <FlatButton key="submit" label={!this.props.draft.isEdit ? "Add" : "Update"} type="submit" />
                    </div>
                </Formsy>
            </Dialog>
        );
    }

    onSubmit(model) {
        const { skill } = this.props.draft;
        if (!skill || !skill.skillId) { return false; }
        model.dateAcquired = model.dateAcquired.toDateString();
        if (!this.props.draft.isEdit) {
            UserActions.addSkill(this.props.userId, skill.skillId, model);
        } else {
            UserActions.updateSkill(this.props.userId, skill.skillId, model);
        }
        DialogActions.close();
    }
}

UserSkillDialog.propTypes = {
    userId: PropTypes.number.isRequired,
};

UserSkillDialog.defaultProps = {
};

export default asDialog(UserSkillDialog);
